module.exports = __webpack_public_path__ + "static/media/Curve.d40061f0.png";